import { render, staticRenderFns } from "./goodsTag.vue?vue&type=template&id=02c08c04&scoped=true"
import script from "./goodsTag.vue?vue&type=script&lang=js"
export * from "./goodsTag.vue?vue&type=script&lang=js"
import style0 from "./goodsTag.vue?vue&type=style&index=0&id=02c08c04&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c08c04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02c08c04')) {
      api.createRecord('02c08c04', component.options)
    } else {
      api.reload('02c08c04', component.options)
    }
    module.hot.accept("./goodsTag.vue?vue&type=template&id=02c08c04&scoped=true", function () {
      api.rerender('02c08c04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rsManagement/goodsLabel/goodsTag.vue"
export default component.exports